import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-night py-10" data-id="element-119">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="glass rounded-3xl p-8 md:p-12 relative overflow-hidden border-gold-accent/40" style={{
        borderColor: 'rgba(224,178,76,0.4)'
      }} data-id="element-121">
          <div className="absolute top-0 left-0 w-full h-1 bg-gold-accent" data-id="element-122"></div>

          <div className="w-20 h-20 bg-gold-accent/15 border border-gold-accent/30 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-123">
            <ShieldCheck className="w-10 h-10 text-gold-accent" data-id="element-124" />
          </div>

          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-125">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-textLight mb-6 leading-relaxed" data-id="element-126">
            Abrís los tomos. Los estudiás. Los usás. Si en 7 días no es lo que
            esperabas — devolución del 100%. Sin formularios. Sin drama. Sin
            explicaciones.
          </p>

          <div className="inline-block bg-gold-accent/10 border border-gold-accent/30 px-4 py-2 rounded-full text-gold-accent font-bold text-sm" data-id="element-127">
            Tasa de devoluciones: menos del 1%.
          </div>
        </motion.div>
      </div>
    </section>;
}